// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { avoidBreakAfterPrintElement, color, xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

pageTitleStyles.brandStyles = {
    logoImage: {
        css: css`
            img {
                max-width: 150px;
                max-height: 150px;
                ${xScreen("lte", "xs")} {
                    max-width: 80px;
                    max-height: 80px;
                }
                ${avoidBreakAfterPrintElement}
            }
        `,
    },
    nameText: {
        size: 14,
        lineHeight: "22px",
        weight: "normal",
        color: "text",
    },

    nameLink: {
        typographyProps: {
            size: 14,
            lineHeight: "22px",
            weight: "normal",
            color: "text",
            css: css`
                &&& {
                    color: ${color("text")};
                }
            `,
        },
    },
};

pageTitleStyles.titleText = {
    variant: "h1",
    as: "h2",
    css: css`
        margin-bottom: 12px;
    `,
};
